<template>
  <div class="dobetter-uploader">

          <input type="file" v-on:change="onFileSelected" ref="fileinput" multiple="multiple" accept=".jpg,.jpeg">
          <button v-on:click="$refs.fileinput.click()">Datei wählen</button>
<!--           <button v-on:click="onUpload">Upload</button> -->
<!--
          <div class="outputImg thickBorder">
          <label class="notMove" for="uploadData">
            <i class="picture-icon" aria-hidden="true"></i>
            <input id="uploadData" type="file" accept=".gif,.jpg,.png,.pdf,.odf,.doc,.docx,.mp4,.mov,.webm,.mpeg,.mpg,.zip" name="uploadData[]" multiple />
            <span>Foto hinzufügen</span>
          </label>
          </div>
  
          <div class='progress' id="progress_div">
            <div class='bar' id='bar'></div>
            <div class='percent' id='percent'>0%</div>  
          </div>
-->
  </div>
</template>
<script>
  
  export default{
    name: 'dobetterUploader',
    props: ['articlenumber','uploadedImages'],
    data (){
      return {
        selectedFiles: null,
      }
    },
    mounted: function(){
      console.log( typeof this.uploadedImages )
    },
    methods: {
      
        onFileSelected(e){
          this.selectedFiles = e.target.files
          this.onUpload();
        },
        
        onUpload(){
                    
          const { selectedFiles, articlenumber } = this;
          const { dispatch } = this.$store;
            
          if (selectedFiles && articlenumber) {
                dispatch('products/uploadImages', { selectedFiles, articlenumber })
                  .then( (data) => {           
                                               
                        var newPics = JSON.parse( data.json )
                        var oldPics = this.uploadedImages && this.uploadedImages.length > 0 ? this.uploadedImages  : [] //this.uploadedImages;
                                                
                        newPics.forEach(function(img){
                          oldPics.push(img)
                        });
                        
                       this.$emit('update:uploadedImages', oldPics)
                  });
            }
          
        },
      
      

/*
       uploadFormDataProgress( oupAnz ) {
          
        
          var bar = $('#bar');
          
          console.log(bar);
          
          var percent = $('#percent');
          $('.ajaxForm').ajaxForm({
            dataType: 'json',
            url: '/api/xi/',
            beforeSubmit: function() {
              
              $("#progress_div").addClass('vis');
              var percentVal = '0%';
              bar.width(percentVal)
              percent.html(percentVal);
            },
        
            uploadProgress: function(event, position, total, percentComplete) {
              var percentVal = percentComplete + '%';
              bar.width(percentVal)
              percent.html(percentVal);
            },
            
          success: function() {
              var percentVal = '100%';
              bar.width(percentVal)
              percent.html(percentVal);
            },
        
            complete: function(xhr) {
              console.log( xhr.responseText );
              var out=$.parseJSON(xhr.responseText);
              console.log( out.success );

              if(out.success == true)
              {
                  out.htmlCode.forEach( function(currentValue, index, arr) {
                    var oupAnz = $('.outputImg').length;
                    var newFotoInput = $('<input>').attr('type','hidden').attr('name','fotoFiles[]').val(out.url[index] );
                var newFoto = $('<div></div>').addClass('outputImg').addClass('uploadFoto').attr('id', 'output_image-' + oupAnz ).html(currentValue).append(newFotoInput);
                $('#fotolist').prepend(newFoto);
              });
              //console.log(xhr.responseText);
              }

              $("#progress_div").removeClass('vis');
              $('input[type="file"]').val('');


            }
          }); 
        },
*/

    },
  }  
  
  
</script>
<style scoped>
  .dobetter-uploader { border: 0 solid #787878; }
  

  button { white-space: normal !important; height: auto; }
  
  label[for="uploadData"] { float: none; position: relative; display: inline-block !important; padding:0; width: 8.5rem; height: 8.5rem; text-align: center; cursor: pointer; padding-top: 2rem;
  			-webkit-transition: all .3s ease-in-out;
  		transition: all .3s ease-in-out;
  		-moz-transition: all .3s ease-in-out;
  		-ms-transition: all .3s ease-in-out;
  		-o-transition: all .3s ease-in-out;
  		top: 0;
  		-webkit-transform: translate(0);
  		transform: translate(0);
  		overflow: hidden;	
  }
  
  label[for="uploadData"]:hover { border-color: #ff7200; }
  label[for="uploadData"] i { display: inline-block; height: 4rem; width: 4rem; color: #ff7200; background: yellow;}
  label[for="uploadData"] span { display: none; }
  label[for="uploadData"]:after { position: absolute; border: 0; top: 1.1311rem; right: 1.23rem; height: 2rem; width: 2rem; background: red; content: ""; color: #449300 /*telefon*/; line-height: 1; }
  
  
  input[type="file"] { display: none; }
  
  
  #fotolist { vertical-align: middle; line-height: 1; }
  .outputImg { float: left; position: relative; display: inline-block; border: 1px solid #ddd; border-radius: 3px; padding:0; width: 8.5rem; height: 8.5rem; text-align: center; cursor: pointer; margin: 0.4em; 
  		-webkit-transition: all .3s ease-in-out;
  		transition: all .3s ease-in-out;
  		-moz-transition: all .3s ease-in-out;
  		-ms-transition: all .3s ease-in-out;
  		-o-transition: all .3s ease-in-out;
  		overflow: hidden;
  		background: #fff; 
  		border: 3px solid #343434;
  }
 .outputImg.thickBorder { border: 3px solid #ff7200; clear: left; } 
 .outputImg img { height: 8.5rem; width: 8.5rem; display: block; margin: 0 auto; -webkit-object-fit: cover !important; object-fit: cover !important; }
  
  .progress 
  {
    clear: both; 	
    position:relative; 
    width: auto; margin: 0 auto; 
    max-width:400px; 
    border: 1px solid #ff7200; 
    padding: 1px; 
    border-radius: 3px ; 
    visibility: hidden;
  }
  .bar 
  { 
    background-color: #ff7200 /*telefon*/; 
    width:0%; 
    height:20px; 
    border-radius: 3px; 
  }
  .percent 
  { 
    position:absolute; 
    display:inline-block; 
    top:3px; 
    left:48%; 
  }
  #progress_div.vis { visibility: visible; }
  
</style>